/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { getStorageItem, setStorageItem } from '@utils/storage.ts';
import { CookingPermission, hasUserRolePermission, isUserRole, UserRole } from '@models/user/user';

export interface StoredUserInfo {
    role?: number;
    [key: string]: unknown;
}

export function getUserInfo(): StoredUserInfo {
    try {
        return JSON.parse(getStorageItem('user-info') ?? '{}');
    } catch {
        setStorageItem('user-info', '{}');
        return {};
    }
}

export function isUserInRoles(roles: number[]): boolean {
    const userInfo = getUserInfo();
    return roles.some((role) => isUserRole(Number(userInfo.role), role));
}

export function isUserInRole(role: number): boolean {
    return isUserInRoles([role]);
}

export function hasCookingPermission(permission: CookingPermission, userInfo: StoredUserInfo = getUserInfo()): boolean {
    if (isUserRole(Number(userInfo.role), UserRole.SuperAdmin)) return true;
    return hasUserRolePermission(Number(userInfo.role), permission);
}

export function canEditCooking(userInfo: StoredUserInfo = getUserInfo()): boolean {
    return hasCookingPermission(CookingPermission.Edit, userInfo);
}
